import { render, staticRenderFns } from "./StatisticsCourse.vue?vue&type=template&id=1eec41b2&scoped=true&"
import script from "./StatisticsCourse.vue?vue&type=script&lang=js&"
export * from "./StatisticsCourse.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsCourse.vue?vue&type=style&index=0&id=1eec41b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eec41b2",
  null
  
)

export default component.exports